import ReportingPeriod from "../components/FinancialReporting/ReportingPeriod";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, KeyValue } from "../interfaces";
import { updateFilter, updateUi } from "../common/actions";

function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateLatestReportPeriod: (reportPeriod: string) => {
      dispatch(updateUi("latestReportPeriod", reportPeriod));
    },
    updateReportPeriod: (reportPeriod: string[]) => {
      dispatch(updateFilter("reportPeriod", reportPeriod));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ReportingPeriod);
